var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaImageDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic images",
    clipPath: "url(#clip0_9146_76344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic images"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 10,
    cy: 10,
    r: 4,
    fill: "url(#paint0_linear_9146_76344)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 10,
    cy: 10,
    r: 2,
    fill: "#8BABF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_76344",
    x1: 1.62667,
    y1: 7.41436,
    x2: 12.391,
    y2: 16.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FCFBFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaImageDark);
export default __webpack_public_path__ + "static/media/figma-image-dark.31f080e432a25dd5506ee9064908e51c.svg";
export { ForwardRef as ReactComponent };